import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL, goToCheckout } from "../utils/pixel";
import { mainCtaLabel } from "../data/content";
type CheckoutButtonProps = {
  label?: string;
  className?: string;
};
export function CheckoutButton({
  label = mainCtaLabel,
  className = ""
}: CheckoutButtonProps) {
  return <a href={CHECKOUT_URL} onClick={e => {
    e.preventDefault();
    goToCheckout();
  }} className={`inline-flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-4 text-center text-base font-bold leading-snug text-ink transition-transform duration-150 ease-out hover:-translate-y-0.5 active:scale-[0.98] sm:px-8 ${className}`} data-id="element-30" data-mp="1nkbony6osblu">
      {label}
      <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden data-id="element-31" data-mp="14nk0pbg798bg" />
    </a>;
}